import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";

interface Props {
  value: string;
  placeholder: string;
  onInputChange: Function;
  className?: string;
}

const SearchInput = ({
  value,
  onInputChange,
  placeholder,
  className = "",
}: Props) => {
  return (
    <div className={`relative show-element-animation-ease-in-out ${className}`}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        className={"rounded-full w-full text-neutral-100 placeholder:text-neutral-400 pl-14 pr-4 py-2 text-base bg-neutral-600 border border-neutral-500 ring-offset-2 ring-0 ring-offset-neutral-800 focus:ring-1 focus:ring-[#008DD2] focus:outline-none transition"}
        onInput={(e) => onInputChange(e)}
      />
      <div className={"absolute top-1/2 left-3 -translate-y-1/2 flex space-x-3"}>
        <MagnifyingGlassIcon className={"w-5 h-5 text-neutral-50"} />
        <div className={"h-5 w-[1px] bg-neutral-500"} />
      </div>
    </div>
  );
};
export default SearchInput;
